module.exports = __webpack_public_path__ + "img/icon-more.35b1df37.svg";